import React from 'react';
import { useSound } from '../sounds';

export interface DiamondKeypadProps {
  value: string;
  onChange: (value: string) => void;
}

const Btn: React.FC<{ label: string; extraClass?: string; onClick: () => void }> = ({
  label,
  extraClass = 'keypad-btn-digit',
  onClick,
}) => (
  <button className={`keypad-btn ${extraClass}`} onClick={onClick}>
    <span>{label}</span>
  </button>
);

export const DiamondKeypad: React.FC<DiamondKeypadProps> = ({ value, onChange }) => {
  const playSound = useSound();
  const append = (ch: string) => { playSound('keypad-press'); onChange(value + ch); };
  const backspace = () => { playSound('keypad-press'); onChange(value.slice(0, -1)); };

  return (
    <div className="diamond-keypad">
      <div className="diamond-keypad-row">
        <Btn label="1" onClick={() => append('1')} />
        <Btn label="2" onClick={() => append('2')} />
        <Btn label="3" onClick={() => append('3')} />
      </div>
      <div className="diamond-keypad-row">
        <Btn label="4" onClick={() => append('4')} />
        <Btn label="5" onClick={() => append('5')} />
        <Btn label="6" onClick={() => append('6')} />
        <Btn label="7" onClick={() => append('7')} />
      </div>
      <div className="diamond-keypad-row">
        <Btn label="8" onClick={() => append('8')} />
        <Btn label="9" onClick={() => append('9')} />
        <Btn label="0" onClick={() => append('0')} />
      </div>
      <div className="diamond-keypad-row">
        <Btn label="." extraClass="keypad-btn-decimal" onClick={() => append('.')} />
        <Btn label="⌫" extraClass="keypad-btn-backspace" onClick={backspace} />
      </div>
    </div>
  );
};
